import React from 'react';
import { ProgressHeader } from './components/ProgressHeader/ProgressHeader';
import { StepsList, Step } from './components/StepsList/StepsList';
import { TwoColumnLayout } from '../layouts';
import { useProgressTimer } from './hooks/useProgressTimer';

interface Props {
  steps: Step[];
  onComplete?: () => void;
  background?: string;
  mainContentSpan?: number;
  mainCellStyle?: React.CSSProperties;
  sideCellStyle?: React.CSSProperties;
  isLoading?: boolean;
}

export function TwoColumnProgressBar({
  steps,
  onComplete,
  background,
  mainContentSpan = 8,
  mainCellStyle,
  sideCellStyle,
  isLoading = false,
}: Props) {
  useProgressTimer({ steps, background, isLoading, onComplete });

  return (
    <TwoColumnLayout
      mainContent={<ProgressHeader />}
      sideContent={<StepsList />}
      mainContentSpan={mainContentSpan}
      mainCellStyle={mainCellStyle}
      sideCellStyle={sideCellStyle}
    />
  );
}
